import '.cb{display:inline-flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.k6{padding:0.6rem;}.ssr-plugin'
import '.i3{border-radius:1.875rem;}.ssr-plugin'
import '.k7{border:1px solid var(--palette-blue-50);}.ssr-plugin'
import '.k8{box-shadow:0 1rem 2rem 0.5rem var(--palette-blue-50);}.ssr-plugin'
import '.k9{--page-min-height:auto;}.ssr-plugin'
import '.dj{border-radius:2rem;}.ssr-plugin'
import '.ka{overflow-x:hidden;}.ssr-plugin'
import '.by{overflow-y:auto;}.ssr-plugin'
import '.kb{background:var(--page-bg);}.ssr-plugin'
import '.ag{position:relative;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { ReactNode } from 'react'

export type PhoneFrameProps = {
  children: ReactNode
  width?: number
  height?: number
  style?: Style
}

export const PhoneFrame = ({
  children,
  width = 390,
  height = 760,
  style,
}: PhoneFrameProps) => {
  return (
    <styled.div className="cb e t v k6 i3 k7 k8"
      style={{
        ...style,
      }}
    >
      <styled.div className="k9 dj ka by kb ag"
        style={{
          width,
          height,} as Style}
      >
        <div style={{ pointerEvents: 'none' }}>{children}</div>
      </styled.div>
    </styled.div>
  )
}
